import { Controller } from "@hotwired/stimulus"
import { toast } from "../lib/toast"

export default class extends Controller {
  static values = {
    url: String,
  }

  connect() {
    this.csrfToken = document.querySelector('meta[name="csrf-token"]').content
  }

  update(event) {
    const select = event.target
    const row = select.closest('tr')
    if (!row) return
    const twUserId = row.dataset.userId
    const field = select.dataset.field
    const value = select.value
    if (!twUserId || !field) return

    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken,
        'Accept': 'application/json',
      },
      body: JSON.stringify({
        tw_user: {
          id: twUserId,
          tw_user_attribute_attributes: { [field]: value },
        },
      }),
    })
      .then((r) => r.json())
      .then((json) => {
        if (json && json.msg === 'success') {
          this.highlight(row, 'success')
          toast('保存しました', 'success')
        } else {
          this.highlight(row, 'error')
          toast('保存に失敗しました', 'error')
        }
      })
      .catch(() => {
        this.highlight(row, 'error')
        toast('通信エラーが発生しました', 'error')
      })
  }

  highlight(row, kind) {
    const cls = kind === 'success' ? 'bg-success/10' : 'bg-error/10'
    row.classList.add(cls)
    setTimeout(() => row.classList.remove(cls), 1200)
  }
}

